module.exports = __webpack_public_path__ + "img/assembly.0.1.c9c67840.png";